(function () {
  if (window.FitnessBentoCartAddonsLoaded) {
    return;
  }

  window.FitnessBentoCartAddonsLoaded = true;
  let activeOverlay = null;
  let activePanel = null;
  let activeTrigger = null;
  let activeRoot = null;

  /*
    Tracks whether the customer has already seen the
    add-on modal during the current page load.

    This intentionally resets after a full page refresh.
  */
  let addonsSeen = false;
  function cartHasFixedBundle() {
  return Boolean(
    document.querySelector(
      '[data-cart-delivery-item][data-is-fixed-bundle="true"]'
    )
  );
}

  /* =========================
     MEAL BUNDLE SUBSCRIPTION
     ========================= */

  function getMealBundleSubscription() {
    const bundleItems = document.querySelectorAll(
      '[data-cart-delivery-item][data-is-meal-bundle="true"][data-has-selling-plan="true"]'
    );

    if (!bundleItems.length) {
      return null;
    }

    const bundleItem = bundleItems[0];
    const sellingPlanId = bundleItem.dataset.sellingPlanId;

    if (!sellingPlanId) {
      return null;
    }

    return {
      productId: bundleItem.dataset.productId || null,
      productHandle: bundleItem.dataset.productHandle || null,
      sellingPlanId: sellingPlanId,
      sellingPlanName: bundleItem.dataset.sellingPlanName || ''
    };
  }

  function updateAddonSubscriptionOptions() {
    const bundleSubscription = getMealBundleSubscription();

    document
      .querySelectorAll('[data-fb-addon-frequency]')
      .forEach(function (frequencyBlock) {
        if (bundleSubscription) {
          frequencyBlock.hidden = false;
        } else {
          frequencyBlock.hidden = true;

          const onceOption = frequencyBlock.querySelector(
            '[data-fb-addon-frequency-input][value="once"]'
          );

          if (onceOption) {
            onceOption.checked = true;
          }

          const note = frequencyBlock.querySelector(
            '[data-fb-addon-frequency-note]'
          );

          if (note) {
            note.hidden = true;
          }
        }
      });
  }

  window.fbGetMealBundleSubscription =
    getMealBundleSubscription;

    /* =========================
   INITIALISE INLINE OPTIONS
   ========================= */

function initialiseAddonSubscriptionOptions() {
  updateAddonSubscriptionOptions();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initialiseAddonSubscriptionOptions
  );
} else {
  initialiseAddonSubscriptionOptions();
}


  /* =========================
     MODAL
     ========================= */

  function openAddons(trigger) {
    if (!trigger) return;

    const root = trigger.closest(
      '[data-fb-cart-addons]'
    );

    if (!root) return;

    const overlay = root.querySelector(
      '[data-fb-addons-overlay]'
    );

    const panel = root.querySelector(
      '[data-fb-addons-panel]'
    );

    if (!overlay || !panel) return;

    /*
      Any modal opening counts as having seen
      the add-on offer for this page load.
    */
    addonsSeen = true;

    activeOverlay = overlay;
    activePanel = panel;
    activeTrigger = trigger;
    activeRoot = root;

    updateAddonSubscriptionOptions();

    /*
      Move modal elements under <body> so the
      cart drawer cannot constrain positioning.
    */
    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    overlay.hidden = false;
    panel.hidden = false;

    document.body.classList.add(
      'fb-cart-addons-open'
    );

    const closeButton = panel.querySelector(
      '[data-fb-addons-close]'
    );

    if (closeButton) {
      setTimeout(function () {
        closeButton.focus();
      }, 50);
    }
  }

  function closeAddons() {
    if (!activeOverlay || !activePanel) return;

    activeOverlay.hidden = true;
    activePanel.hidden = true;

    document.body.classList.remove(
      'fb-cart-addons-open'
    );

    /*
      Return modal elements to the original
      component so they can be opened again.
    */
    if (activeRoot) {
      activeRoot.appendChild(activeOverlay);
      activeRoot.appendChild(activePanel);
    }

    if (activeTrigger) {
      activeTrigger.focus();
    }

    activeOverlay = null;
    activePanel = null;
    activeTrigger = null;
    activeRoot = null;
  }


  /* =========================
   CART UI REFRESH
   ========================= */

async function refreshCartAfterAddon() {

  /* ---------------------------------
     FETCH CART DRAWER
     --------------------------------- */

  const drawerResponse = await fetch(
    window.Shopify.routes.root + 'cart?section_id=cart-drawer',
    {
      headers: {
        Accept: 'text/html'
      }
    }
  );

  if (!drawerResponse.ok) {
    throw new Error(
      'Unable to refresh cart drawer.'
    );
  }

  const drawerText =
    await drawerResponse.text();

  const drawerHtml =
    new DOMParser().parseFromString(
      drawerText,
      'text/html'
    );


  /* ---------------------------------
     CART DRAWER ITEMS
     --------------------------------- */

  const currentDrawerItems =
    document.querySelector(
      'cart-drawer-items'
    );

  const freshDrawerItems =
    drawerHtml.querySelector(
      'cart-drawer-items'
    );

  if (
    currentDrawerItems &&
    freshDrawerItems
  ) {
    currentDrawerItems.replaceWith(
      freshDrawerItems
    );
  }


  /* ---------------------------------
     CART DRAWER TOTAL
     --------------------------------- */

  const currentDrawerTotals =
    document.getElementById(
      'FitnessBento-CartDrawer-Totals'
    );

  const freshDrawerTotals =
    drawerHtml.getElementById(
      'FitnessBento-CartDrawer-Totals'
    );

  if (
    currentDrawerTotals &&
    freshDrawerTotals
  ) {
    currentDrawerTotals.innerHTML =
      freshDrawerTotals.innerHTML;
  }


  /* ---------------------------------
     DRAWER STATE
     --------------------------------- */

  const cartDrawer =
    document.querySelector(
      'cart-drawer'
    );

  if (cartDrawer) {
    cartDrawer.classList.remove(
      'is-empty'
    );
  }


  /* ---------------------------------
     FULL CART PAGE
     --------------------------------- */

  const mainCartItems =
    document.getElementById(
      'main-cart-items'
    );

  if (mainCartItems) {

    const itemsResponse = await fetch(
      window.Shopify.routes.root +
        'cart?section_id=main-cart-items',
      {
        headers: {
          Accept: 'text/html'
        }
      }
    );

    if (itemsResponse.ok) {

      const itemsText =
        await itemsResponse.text();

      const itemsHtml =
        new DOMParser().parseFromString(
          itemsText,
          'text/html'
        );

      const currentItemsContents =
        mainCartItems.querySelector(
          '.js-contents'
        );

      const freshItemsContents =
        itemsHtml.querySelector(
          '#main-cart-items .js-contents'
        );

      if (
        currentItemsContents &&
        freshItemsContents
      ) {
        currentItemsContents.innerHTML =
          freshItemsContents.innerHTML;
      }
    }


    /* -------------------------------
   FULL CART TOTAL
   ------------------------------- */

try {
  const cartResponse = await fetch(
    window.Shopify.routes.root +
      'cart.js?_=' +
      Date.now(),
    {
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    }
  );

  if (cartResponse.ok) {
    const cartData =
      await cartResponse.json();

    const currentTotalValue =
      document.querySelector(
        '#main-cart-footer .totals__total-value'
      );

    if (currentTotalValue) {
      const currency =
        cartData.currency || 'AUD';

      const formattedTotal =
        new Intl.NumberFormat(
          'en-AU',
          {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol'
          }
        ).format(
          cartData.total_price / 100
        );

      currentTotalValue.textContent =
        formattedTotal +
        ' ' +
        currency;
    }
  }
} catch (error) {
  console.warn(
    'Fitness Bento cart total refresh failed:',
    error
  );
}
  }

  /* ---------------------------------
     CART ICON BUBBLE
     --------------------------------- */

  try {

    const bubbleResponse = await fetch(
      window.Shopify.routes.root +
        '?section_id=cart-icon-bubble',
      {
        headers: {
          Accept: 'text/html'
        }
      }
    );

    if (bubbleResponse.ok) {

      const bubbleText =
        await bubbleResponse.text();

      const bubbleHtml =
        new DOMParser().parseFromString(
          bubbleText,
          'text/html'
        );

      const currentBubble =
        document.getElementById(
          'cart-icon-bubble'
        );

      const freshBubble =
        bubbleHtml.getElementById(
          'cart-icon-bubble'
        );

      if (
        currentBubble &&
        freshBubble
      ) {
        currentBubble.innerHTML =
          freshBubble.innerHTML;
      }
    }

  } catch (error) {

    console.warn(
      'Fitness Bento cart bubble refresh failed:',
      error
    );

  }


  /* ---------------------------------
     RE-INITIALISE ADD-ON OPTIONS
     --------------------------------- */

  updateAddonSubscriptionOptions();


  /* ---------------------------------
     RECHECK DELIVERY COMPATIBILITY
     --------------------------------- */

  if (
    typeof window
      .fitnessBentoValidateCartDelivery ===
    'function'
  ) {
    window.fitnessBentoValidateCartDelivery(
      document
    );
  }
}


  /* =========================
     QUANTITY
     ========================= */

  function getQuantityInput(element) {
    const product = element.closest(
      '[data-fb-addon-product]'
    );

    if (!product) return null;

    return product.querySelector(
      '[data-fb-addon-qty]'
    );
  }

  function normaliseQuantity(input) {
    if (!input) return 1;

    let quantity =
      parseInt(input.value, 10);

    if (
      !Number.isFinite(quantity) ||
      quantity < 1
    ) {
      quantity = 1;
    }

    input.value = quantity;

    return quantity;
  }


  /* =========================
     ADD TO CART
     ========================= */

  async function addAddon(button) {
    if (!button || button.disabled) return;

    const product = button.closest(
      '[data-fb-addon-product]'
    );

    if (!product) return;

    const variantId =
      product.dataset.variantId;

    const quantityInput =
      product.querySelector(
        '[data-fb-addon-qty]'
      );

    const status =
      product.querySelector(
        '[data-fb-addon-status]'
      );

    const quantity =
      normaliseQuantity(quantityInput);

    const bundleSubscription =
      getMealBundleSubscription();

    const selectedFrequency =
      product.querySelector(
        '[data-fb-addon-frequency-input]:checked'
      );

    const wantsSubscription =
      bundleSubscription &&
      selectedFrequency &&
      selectedFrequency.value ===
        'subscription';

    if (!variantId) {
      if (status) {
        status.textContent =
          'Unable to add this product.';
      }

      return;
    }

    const originalText =
      button.textContent.trim();

    button.disabled = true;
    button.textContent = 'Adding...';

    if (status) {
      status.textContent = '';
    }

    try {
      const item = {
        id: Number(variantId),
        quantity: quantity
      };

      if (wantsSubscription) {
        item.selling_plan = Number(
          bundleSubscription.sellingPlanId
        );
      }

      const response = await fetch(
        window.Shopify.routes.root +
          'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [item]
          })
        }
      );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
            data.message ||
            'Unable to add this product.'
        );
      }

      button.textContent = 'Added ✓';

      if (status) {
        status.textContent =
          quantity === 1
            ? 'Added to your order.'
            : quantity +
              ' added to your order.';
      }

      try {
        await refreshCartAfterAddon();
      } catch (refreshError) {
        console.error(
          'Fitness Bento cart refresh error:',
          refreshError
        );
      }

      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1400);

    } catch (error) {
      console.error(
        'Fitness Bento add-on error:',
        error
      );

      button.disabled = false;
      button.textContent = originalText;

      if (status) {
        status.textContent =
          error.message ||
          'Something went wrong. Please try again.';
      }
    }
  }


  /* =========================
     CHECKOUT INTERCEPTION
     CAPTURE PHASE
     ========================= */

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton =
        event.target.closest(
          '#CartDrawer-Checkout, button[name="checkout"], #checkout'
        );

      if (!checkoutButton) return;

/*
  Fixed-bundle carts may still show add-ons,
  but Checkout should never be interrupted
  by the add-on prompt.
*/
if (cartHasFixedBundle()) {
  return;
}

let addonsTrigger = null;

/*
  Cart drawer Checkout:
  use the add-on trigger inside the drawer.
*/
if (
  checkoutButton.id === 'CartDrawer-Checkout'
) {
  addonsTrigger = document.querySelector(
    '#CartDrawer [data-fb-addons-open]'
  );
}

/*
  Full cart page Checkout:
  use the mobile cart-page add-on trigger.
*/
if (
  checkoutButton.id === 'checkout' &&
  window.matchMedia('(max-width: 749px)').matches
) {
  addonsTrigger = document.querySelector(
    '.fb-cart-page-addons [data-fb-addons-open]'
  );
}

      /*
        Only interrupt Checkout when:

        - eligible add-ons still exist
        - customer has not already seen the modal
          during this page load
      */
      if (
        addonsTrigger &&
        !addonsSeen
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openAddons(addonsTrigger);
      }
    },
    true
  );


  /* =========================
     CLICK EVENTS
     ========================= */

  document.addEventListener(
    'click',
    function (event) {

      /* -------------------------
         MANUAL MODAL OPEN
         ------------------------- */

      const openButton =
        event.target.closest(
          '[data-fb-addons-open]'
        );

      if (openButton) {
        event.preventDefault();

        openAddons(openButton);

        return;
      }


      /* -------------------------
         MODAL CLOSE
         ------------------------- */

      const closeButton =
        event.target.closest(
          '[data-fb-addons-close]'
        );

      if (
        closeButton &&
        activePanel
      ) {
        event.preventDefault();

        closeAddons();

        return;
      }


      /* -------------------------
         OVERLAY CLICK
         ------------------------- */

      if (
        activeOverlay &&
        (
          event.target === activeOverlay ||
          event.target.closest(
            '[data-fb-addons-overlay]'
          )
        )
      ) {
        closeAddons();

        return;
      }


      /* -------------------------
         QUANTITY MINUS
         ------------------------- */

      const minusButton =
        event.target.closest(
          '[data-fb-addon-minus]'
        );

      if (minusButton) {
        event.preventDefault();

        const input =
          getQuantityInput(minusButton);

        if (!input) return;

        const currentQuantity =
          normaliseQuantity(input);

        input.value = Math.max(
          1,
          currentQuantity - 1
        );

        return;
      }


      /* -------------------------
         QUANTITY PLUS
         ------------------------- */

      const plusButton =
        event.target.closest(
          '[data-fb-addon-plus]'
        );

      if (plusButton) {
        event.preventDefault();

        const input =
          getQuantityInput(plusButton);

        if (!input) return;

        const currentQuantity =
          normaliseQuantity(input);

        input.value =
          currentQuantity + 1;

        return;
      }


      /* -------------------------
         ADD PRODUCT
         ------------------------- */

      const addButton =
        event.target.closest(
          '[data-fb-addon-add]'
        );

      if (addButton) {
        event.preventDefault();

        addAddon(addButton);
      }
    }
  );


  /* =========================
     INPUT CHANGES
     ========================= */

  document.addEventListener(
    'change',
    function (event) {

      /* Quantity */

      if (
        event.target.matches(
          '[data-fb-addon-qty]'
        )
      ) {
        normaliseQuantity(
          event.target
        );

        return;
      }


      /* Add-on frequency */

      if (
        event.target.matches(
          '[data-fb-addon-frequency-input]'
        )
      ) {
        const frequencyBlock =
          event.target.closest(
            '[data-fb-addon-frequency]'
          );

        if (!frequencyBlock) return;

        const note =
          frequencyBlock.querySelector(
            '[data-fb-addon-frequency-note]'
          );

        if (!note) return;

        note.hidden =
          event.target.value !==
          'subscription';
      }
    }
  );


  /* =========================
     KEYBOARD
     ========================= */

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        activePanel
      ) {
        closeAddons();
      }
    }
  );

})();